// אנחנו לא מגדירים משתנה חדש, רק אומרים ל-TS מה קיים ב-window

"use strict";
// TS VERSION
import { TRANS } from "./classes";


//-----------------------------------------------------------------------------------------------------------------------------------------

export abstract class oBase {
    //---------------------------------------------------------------------
    //        C# וגם ב  TypeScript מחלקה זו נוצרה באותו תאריך 4.4.2026 גם ב
    //                    abstract אני לא בטוח אם אני רוצה את המחלקה הזאת כ
    //---------------------------------------------------------------------
}


export enum Ilk {
    Undefined = 0,
    Unknown = 0,
    oBool = 1,
    oColor = 2,
    oCsv = 3,
    oDatim = 4,
    oDaton = 5,
    oDouble = 6,
    oFloat = 7,
    oHomin = 8,
    oInt16 = 9,
    oInt32 = 10,
    oInt64 = 11,
    oMay = 12,
    oMemo = 13,
    oText = 14,
    oWkd = 16
}


export class oBool extends oBase {
    OBJ_EXIST: boolean;
    BOOL_CONTENT: boolean;

    constructor(p_OBJ_EXIST: boolean = false, p_BOOL_CONTENT: boolean = false) {
        super();
        //alert("i am boolean constructor");
        // בדיקות תקינות כפי שהיו בקוד המקורי
        if (p_OBJ_EXIST != undefined) {
            if (typeof p_OBJ_EXIST !== 'boolean') {
                alert("oBool.Error: Parameter p_OBJ_EXIST must be a boolean.");
                return;
            }
        }
        if (p_BOOL_CONTENT != undefined) {
            if (typeof p_BOOL_CONTENT !== 'boolean') {
                alert("oBool.Error: Parameter p_BOOL_CONTENT must be a boolean.");
                return;
            }
        }

        // השמה של הערכים
        if (p_OBJ_EXIST != undefined && p_BOOL_CONTENT != undefined) {
            this.OBJ_EXIST = p_OBJ_EXIST;
            this.BOOL_CONTENT = p_BOOL_CONTENT;
        }
        else {
            this.OBJ_EXIST = false;
            this.BOOL_CONTENT = false;
        }
    }

    // מתודות ה-Prototype המקוריות מומרות למתודות של המחלקה
    GetBool() {
        if (this.OBJ_EXIST == true) {
            return this.BOOL_CONTENT;
        }
        else {
            return false;
        }
    }

    GetStrForTableCell_v1() {
        return TRANS.trans_bool_to_cell_str_v1(this.OBJ_EXIST, this.BOOL_CONTENT);
    }

    GetStrForXml_v1() {
        return TRANS.trans_bool_to_xml_str(this.OBJ_EXIST, this.BOOL_CONTENT);
    }

    GetStr() {
        return TRANS.trans_bool_to_xml_str(this.OBJ_EXIST, this.BOOL_CONTENT);
    }
}


export class oColor extends oBase {
    OBJ_EXIST: boolean;
    NUMBER_CONTENT: number;

    constructor(p_OBJ_EXIST: boolean = false, p_NUMBER_CONTENT: number = 0) {
        super();
        // בדיקת תקינות עבור p_OBJ_EXIST
        if (p_OBJ_EXIST != undefined) {
            if (typeof p_OBJ_EXIST !== 'boolean') {
                alert("oColor.Error: Parameter p_OBJ_EXIST must be a boolean.");
                return;
            }
        }

        // בדיקת תקינות עבור p_NUMBER_CONTENT (חייב להיות מספר שלם)
        if (p_NUMBER_CONTENT != undefined) {
            if (typeof p_NUMBER_CONTENT !== 'number' || !Number.isInteger(p_NUMBER_CONTENT)) {
                alert("oColor.Error: Parameter p_NUMBER_CONTENT must be an integer number.");
                return;
            }
        }

        // השמה של הערכים - במידה ושניהם קיימים
        if (p_OBJ_EXIST != undefined && p_NUMBER_CONTENT != undefined) {
            this.OBJ_EXIST = p_OBJ_EXIST;
            this.NUMBER_CONTENT = p_NUMBER_CONTENT;
        }
        else {
            // ערכי ברירת מחדל (Default)
            this.OBJ_EXIST = false;
            this.NUMBER_CONTENT = 0; // צבע כברירת מחדל (למשל שחור או שקוף)
        }
    }

    GetStrForTableCell_v1() {
        return "not implemented";
    }

    GetStrForXml_v1() {
        return "not implemented";
    }

    GetStr() {
        return "not implemented";
    }

}


export class oCsv extends oBase {
    OBJ_EXIST: boolean;
    STRING_CONTENT: string;

    constructor(p_OBJ_EXIST: boolean = false, p_STRING_CONTENT: string = "") {
        super();
        // בדיקת תקינות עבור p_STRING_CONTENT
        if (p_STRING_CONTENT != undefined) {
            if (typeof p_STRING_CONTENT !== 'string') {
                alert("oCsv.Error: Parameter p_STRING_CONTENT must be an string.");
                // debugger;
                return;
            }
        }

        // השמה של הערכים - במידה ושניהם קיימים
        if (p_OBJ_EXIST != undefined && p_STRING_CONTENT != undefined) {
            this.OBJ_EXIST = p_OBJ_EXIST;
            this.STRING_CONTENT = p_STRING_CONTENT;
        }
        else {
            // ערכי ברירת מחדל (Default)
            this.OBJ_EXIST = false;
            this.STRING_CONTENT = "";
        }
    }

    GetStrForTableCell_v1() {
        return "not implemented";
    }

    GetStrForXml_v1() {
        return "not implemented";
    }

    GetStr() {
        return "not implemented";
    }
}



export class oDaton extends oBase {
    OBJ_EXIST: boolean;
    NUMBER_CONTENT: number;

    constructor(p_OBJ_EXIST: boolean = false, p_NUMBER_CONTENT: number = 0) {
        super();
        // בדיקת תקינות עבור p_OBJ_EXIST
        if (p_OBJ_EXIST != undefined) {
            if (typeof p_OBJ_EXIST !== 'boolean') {
                alert("oDaton.Error: Parameter p_OBJ_EXIST must be a boolean.");
                return;
            }
        }

        // בדיקת תקינות עבור p_NUMBER_CONTENT (חייב להיות מספר שלם)
        if (p_NUMBER_CONTENT != undefined) {
            if (typeof p_NUMBER_CONTENT !== 'number' || !Number.isInteger(p_NUMBER_CONTENT)) {
                alert("oDaton.Error: Parameter p_NUMBER_CONTENT must be an integer number.");
                return;
            }
        }

        // השמה של הערכים - במידה ושניהם קיימים
        if (p_OBJ_EXIST != undefined && p_NUMBER_CONTENT != undefined) {
            this.OBJ_EXIST = p_OBJ_EXIST;
            this.NUMBER_CONTENT = p_NUMBER_CONTENT;
        }
        else {
            // ערכי ברירת מחדל (Default)
            this.OBJ_EXIST = false;
            this.NUMBER_CONTENT = -1; // מציין תאריך לא תקין או חסר
        }
    }

    // החזרת הערך המספרי של התאריך
    GetDaton() {
        if (this.OBJ_EXIST == true) {
            return this.NUMBER_CONTENT;
        }
        else {
            return (-1);
        }
    }

    // חישוב יום בשבוע (מספרי) באמצעות TRANS
    GetWkd() {
        if (this.OBJ_EXIST == false || this.NUMBER_CONTENT == (-1)) {
            return (-1);
        }
        const wkd = TRANS.trans_daton_to_wkd(this.NUMBER_CONTENT);
        return wkd;
    }

    // החזרת שם יום השבוע בעברית
    GetWkd_as_str_v1() {
        const wkd = this.GetWkd();
        if (wkd == (-1)) {
            return "";
        }
        const daysOfWeek = ['יום ראשון', 'יום שני', 'יום שלישי', 'יום רביעי', 'יום חמישי', 'יום שישי', 'יום שבת'];
        const index = (wkd - 1);
        const wkd_str = daysOfWeek[index];
        return wkd_str;
    }

    // מתודות המרה לטקסט (לצורך תצוגה או XML)
    GetStrForTableCell_v1() {
        return TRANS.trans_daton_to_cell_str_v1(this.OBJ_EXIST, this.NUMBER_CONTENT);
    }

    GetStrForXml_v1() {
        return TRANS.trans_daton_to_xml_str(this.OBJ_EXIST, this.NUMBER_CONTENT);
    }

    GetStr() {
        // שימוש בפונקציית ה-XML כברירת מחדל
        return TRANS.trans_daton_to_xml_str(this.OBJ_EXIST, this.NUMBER_CONTENT);
    }
}

export class oDatim {
    // not implemented
}


export class oDouble extends oBase {
    OBJ_EXIST: boolean;
    NUMBER_CONTENT: number;

    constructor(p_OBJ_EXIST: boolean = false, p_NUMBER_CONTENT: number = 0) {
        super();
        // בדיקת תקינות עבור p_OBJ_EXIST
        if (p_OBJ_EXIST != undefined) {
            if (typeof p_OBJ_EXIST !== 'boolean') {
                alert("oDouble.Error: Parameter p_OBJ_EXIST must be a boolean.");
                return;
            }
        }

        // בדיקת תקינות עבור p_NUMBER_CONTENT
        // ב-Double אנחנו מאפשרים כל מספר (גם שלם וגם עשרוני)
        if (p_NUMBER_CONTENT != undefined) {
            if (typeof p_NUMBER_CONTENT !== 'number') {
                alert("oDouble.Error: Parameter p_NUMBER_CONTENT must be a number.");
                return;
            }
        }

        // השמה של הערכים
        if (p_OBJ_EXIST != undefined && p_NUMBER_CONTENT != undefined) {
            this.OBJ_EXIST = p_OBJ_EXIST;
            this.NUMBER_CONTENT = p_NUMBER_CONTENT;
        }
        else {
            // ערכי ברירת מחדל
            this.OBJ_EXIST = false;
            this.NUMBER_CONTENT = 0.0;
        }
    }

    GetStrForTableCell_v1() {
        return "not implemented";
    }

    GetStrForXml_v1() {
        return "not implemented";
    }

    GetStr() {
        return "not implemented";
    }
}

export class oFloat extends oBase {
    OBJ_EXIST: boolean;
    NUMBER_CONTENT: number;

    constructor(p_OBJ_EXIST: boolean = false, p_NUMBER_CONTENT: number = 0) {
        super();
        // בדיקת תקינות עבור p_OBJ_EXIST
        if (p_OBJ_EXIST != undefined) {
            if (typeof p_OBJ_EXIST !== 'boolean') {
                alert("oFloat.Error: Parameter p_OBJ_EXIST must be a boolean.");
                return;
            }
        }

        // בדיקת תקינות עבור p_NUMBER_CONTENT
        if (p_NUMBER_CONTENT != undefined) {
            if (typeof p_NUMBER_CONTENT !== 'number') {
                alert("oFloat.Error: Parameter p_NUMBER_CONTENT must be a number.");
                return;
            }
        }

        // השמה של הערכים
        if (p_OBJ_EXIST != undefined && p_NUMBER_CONTENT != undefined) {
            this.OBJ_EXIST = p_OBJ_EXIST;
            this.NUMBER_CONTENT = p_NUMBER_CONTENT;
        }
        else {
            // ערכי ברירת מחדל
            this.OBJ_EXIST = false;
            this.NUMBER_CONTENT = 0.0;
        }
    }

    GetStrForTableCell_v1() {
        return "not implemented";
    }

    GetStrForXml_v1() {
        return "not implemented";
    }

    GetStr() {
        return "not implemented";
    }
}

export class oHomin extends oBase {
    OBJ_EXIST: boolean;
    NUMBER_CONTENT: number;

    constructor(p_OBJ_EXIST: boolean = false, p_NUMBER_CONTENT: number = 0) {
        super();
        // בדיקת תקינות עבור p_OBJ_EXIST
        if (p_OBJ_EXIST != undefined) {
            if (typeof p_OBJ_EXIST !== 'boolean') {
                alert("oHomin.Error: Parameter p_OBJ_EXIST must be a boolean.");
                return;
            }
        }

        // בדיקת תקינות עבור p_NUMBER_CONTENT (חייב להיות מספר שלם)
        if (p_NUMBER_CONTENT != undefined) {
            if (typeof p_NUMBER_CONTENT !== 'number' || !Number.isInteger(p_NUMBER_CONTENT)) {
                alert("oHomin.Error: Parameter p_NUMBER_CONTENT must be an integer number.");
                return;
            }
        }

        // השמה של הערכים
        if (p_OBJ_EXIST != undefined && p_NUMBER_CONTENT != undefined) {
            this.OBJ_EXIST = p_OBJ_EXIST;
            this.NUMBER_CONTENT = p_NUMBER_CONTENT;
        }
        else {
            // ערכי ברירת מחדל
            this.OBJ_EXIST = false;
            this.NUMBER_CONTENT = -1;
        }
    }

    GetHomin() {
        if (this.OBJ_EXIST == true) {
            return this.NUMBER_CONTENT;
        }
        else {
            return (-1);
        }
    }

    GetStrForTableCell_v1() {
        return TRANS.trans_homin_to_cell_str_v1(this.OBJ_EXIST, this.NUMBER_CONTENT);
    }

    GetStrForXml_v1() {
        return TRANS.trans_homin_to_xml_str(this.OBJ_EXIST, this.NUMBER_CONTENT);
    }

    GetStr() {
        return TRANS.trans_homin_to_xml_str(this.OBJ_EXIST, this.NUMBER_CONTENT);
    }
}

export class oInt16 extends oBase {
    OBJ_EXIST: boolean;
    NUMBER_CONTENT: number;

    constructor(p_OBJ_EXIST: boolean = false, p_NUMBER_CONTENT: number = 0) {
        super();
        // בדיקת תקינות עבור p_OBJ_EXIST
        if (p_OBJ_EXIST != undefined) {
            if (typeof p_OBJ_EXIST !== 'boolean') {
                alert("oInt16.Error: Parameter p_OBJ_EXIST must be a boolean.");
                return;
            }
        }

        // בדיקת תקינות עבור p_NUMBER_CONTENT
        if (p_NUMBER_CONTENT != undefined) {
            if (typeof p_NUMBER_CONTENT !== 'number' || !Number.isInteger(p_NUMBER_CONTENT)) {
                alert("oInt16.Error: Parameter p_NUMBER_CONTENT must be an integer number.");
                return;
            }
        }

        // השמה של הערכים
        if (p_OBJ_EXIST != undefined && p_NUMBER_CONTENT != undefined) {
            this.OBJ_EXIST = p_OBJ_EXIST;
            this.NUMBER_CONTENT = p_NUMBER_CONTENT;
        }
        else {
            this.OBJ_EXIST = false;
            this.NUMBER_CONTENT = 0;
        }
    }

    GetStrForTableCell_v1() {
        return "not implemented";
    }

    GetStrForXml_v1() {
        return "not implemented";
    }

    GetStr() {
        return TRANS.trans_int_to_xml_str(this.OBJ_EXIST, this.NUMBER_CONTENT);
    }
}

export class oInt32 extends oBase {
    OBJ_EXIST: boolean;
    NUMBER_CONTENT: number;

    constructor(p_OBJ_EXIST: boolean = false, p_NUMBER_CONTENT: number = 0) {
        super();
        if (p_OBJ_EXIST != undefined) {
            debugger;
            if (typeof p_OBJ_EXIST !== 'boolean') {
                alert("oInt32.Error: Parameter p_OBJ_EXIST must be a boolean.");
                return;
            }
        }

        if (p_NUMBER_CONTENT != undefined) {
            if (typeof p_NUMBER_CONTENT !== 'number' || !Number.isInteger(p_NUMBER_CONTENT)) {
                alert("oInt32.Error: Parameter p_NUMBER_CONTENT must be an integer number.");
                return;
            }
        }

        if (p_OBJ_EXIST != undefined && p_NUMBER_CONTENT != undefined) {
            this.OBJ_EXIST = p_OBJ_EXIST;
            this.NUMBER_CONTENT = p_NUMBER_CONTENT;
        }
        else {
            this.OBJ_EXIST = false;
            this.NUMBER_CONTENT = 0;
        }
    }

    GetIntOrParameter(p_par: number) {
        if (this.OBJ_EXIST == true) {
            return this.NUMBER_CONTENT;
        }
        else {
            return p_par;
        }
    }

    GetStrForTableCell_v1() {
        return TRANS.trans_int_to_cell_str_v1(this.OBJ_EXIST, this.NUMBER_CONTENT);
    }

    GetStrForXml_v1() {
        return TRANS.trans_int_to_xml_str(this.OBJ_EXIST, this.NUMBER_CONTENT);
    }

    GetStr() {
        return TRANS.trans_int_to_xml_str(this.OBJ_EXIST, this.NUMBER_CONTENT);
    }
}



export class oInt64 extends oBase {
    OBJ_EXIST: boolean;
    NUMBER_CONTENT: number;

    constructor(p_OBJ_EXIST: boolean = false, p_NUMBER_CONTENT: number = 0) {
        super();
        if (p_OBJ_EXIST != undefined) {
            if (typeof p_OBJ_EXIST !== 'boolean') {
                alert("oInt64.Error: Parameter p_OBJ_EXIST must be a boolean.");
                return;
            }
        }

        if (p_NUMBER_CONTENT != undefined) {
            if (typeof p_NUMBER_CONTENT !== 'number' || !Number.isInteger(p_NUMBER_CONTENT)) {
                alert("oInt64.Error: Parameter p_NUMBER_CONTENT must be an integer number.");
                return;
            }
        }

        if (p_OBJ_EXIST != undefined && p_NUMBER_CONTENT != undefined) {
            this.OBJ_EXIST = p_OBJ_EXIST;
            this.NUMBER_CONTENT = p_NUMBER_CONTENT;
        }
        else {
            this.OBJ_EXIST = false;
            this.NUMBER_CONTENT = 0;
        }
    }

    GetIntOrMinusOne() {
        if (this.OBJ_EXIST == true) {
            return this.NUMBER_CONTENT;
        }
        else {
            return (-1);
        }
    }

    GetIntOrParameter(p_par: number) {
        if (this.OBJ_EXIST == true) {
            return this.NUMBER_CONTENT;
        }
        else {
            return p_par;
        }
    }

    GetStrForTableCell_v1() {
        return TRANS.trans_int_to_cell_str_v1(this.OBJ_EXIST, this.NUMBER_CONTENT);
    }

    GetStrForXml_v1() {
        return TRANS.trans_int_to_xml_str(this.OBJ_EXIST, this.NUMBER_CONTENT);
    }

    GetStr() {
        return TRANS.trans_int_to_xml_str(this.OBJ_EXIST, this.NUMBER_CONTENT);
    }
}


export class oMay extends oBase {
    OBJ_EXIST: boolean;
    NUMBER_CONTENT: number;

    constructor(p_OBJ_EXIST: boolean = false, p_NUMBER_CONTENT: number = 0) {
        super();
        // בדיקת תקינות עבור p_OBJ_EXIST
        if (p_OBJ_EXIST != undefined) {
            if (typeof p_OBJ_EXIST !== 'boolean') {
                alert("oMay.Error: Parameter p_OBJ_EXIST must be a boolean.");
                return;
            }
        }

        // בדיקת תקינות עבור p_NUMBER_CONTENT (חייב להיות מספר שלם)
        if (p_NUMBER_CONTENT != undefined) {
            if (typeof p_NUMBER_CONTENT !== 'number' || !Number.isInteger(p_NUMBER_CONTENT)) {
                alert("oMay.Error: Parameter p_NUMBER_CONTENT must be an integer number.");
                return;
            }
        }

        // השמה של הערכים
        if (p_OBJ_EXIST != undefined && p_NUMBER_CONTENT != undefined) {
            this.OBJ_EXIST = p_OBJ_EXIST;
            this.NUMBER_CONTENT = p_NUMBER_CONTENT;
        }
        else {
            // ערכי ברירת מחדל
            this.OBJ_EXIST = false;
            this.NUMBER_CONTENT = 0;
        }
    }

    // מתודות זהות ל-oInt32
    GetIntOrParameter(p_par: number) {
        if (this.OBJ_EXIST == true) {
            return this.NUMBER_CONTENT;
        }
        else {
            return p_par;
        }
    }

    GetStrForTableCell_v1() {
        return TRANS.trans_int_to_cell_str_v1(this.OBJ_EXIST, this.NUMBER_CONTENT);
    }

    GetStrForXml_v1() {
        return TRANS.trans_int_to_xml_str(this.OBJ_EXIST, this.NUMBER_CONTENT);
    }

    GetStr() {
        return TRANS.trans_int_to_xml_str(this.OBJ_EXIST, this.NUMBER_CONTENT);
    }
}

export class oMemo extends oBase {
    OBJ_EXIST: boolean;
    STRING_CONTENT: string;

    constructor(p_OBJ_EXIST: boolean = false, p_STRING_CONTENT: string = "") {
        super();
        // בדיקת תקינות עבור p_STRING_CONTENT
        if (p_STRING_CONTENT != undefined) {
            if (typeof p_STRING_CONTENT !== 'string') {
                alert("oMemo.Error: Parameter p_STRING_CONTENT must be an string.");
                return;
            }
        }

        // השמה של הערכים
        if (p_OBJ_EXIST != undefined && p_STRING_CONTENT != undefined) {
            this.OBJ_EXIST = p_OBJ_EXIST;
            this.STRING_CONTENT = p_STRING_CONTENT;
        }
        else {
            // ערכי ברירת מחדל
            this.OBJ_EXIST = false;
            this.STRING_CONTENT = "";
        }
    }

    GetStrForTableCell_v1() {
        return TRANS.trans_text_to_cell_str_v1(this.OBJ_EXIST, this.STRING_CONTENT);
    }

    GetStrForXml_v1() {
        return TRANS.trans_text_to_xml_str(this.OBJ_EXIST, this.STRING_CONTENT);
    }

    GetStr() {
        return TRANS.trans_text_to_xml_str(this.OBJ_EXIST, this.STRING_CONTENT);
    }
}
export class oText extends oBase {
    OBJ_EXIST: boolean;
    STRING_CONTENT: string;

    constructor(p_OBJ_EXIST: boolean = false, p_STRING_CONTENT: string = "") {
        super();
        // בדיקת תקינות עבור p_STRING_CONTENT
        if (p_STRING_CONTENT != undefined) {
            if (typeof p_STRING_CONTENT !== 'string') {
                alert("oText.Error: Parameter p_STRING_CONTENT must be a string.");
                return;
            }
        }

        // השמה של הערכים
        if (p_OBJ_EXIST != undefined && p_STRING_CONTENT != undefined) {
            this.OBJ_EXIST = p_OBJ_EXIST;
            this.STRING_CONTENT = p_STRING_CONTENT;
        }
        else {
            // ערכי ברירת מחדל
            this.OBJ_EXIST = false;
            this.STRING_CONTENT = "";
        }
    }

    GetString() {
        if (this.OBJ_EXIST == true) {
            return this.STRING_CONTENT;
        }
        else {
            return "";
        }
    }

    GetStrForTableCell_v1() {
        return TRANS.trans_text_to_cell_str_v1(this.OBJ_EXIST, this.STRING_CONTENT);
    }

    GetStrForXml_v1() {
        return TRANS.trans_text_to_xml_str(this.OBJ_EXIST, this.STRING_CONTENT);
    }

    GetStr() {
        return TRANS.trans_text_to_xml_str(this.OBJ_EXIST, this.STRING_CONTENT);
    }
}

export class oWkd extends oBase {
    OBJ_EXIST: boolean;
    NUMBER_CONTENT: number;

    constructor(p_OBJ_EXIST: boolean = false, p_NUMBER_CONTENT: number = 0) {
        super();
        // בדיקת תקינות עבור p_OBJ_EXIST
        if (p_OBJ_EXIST != undefined) {
            if (typeof p_OBJ_EXIST !== 'boolean') {
                alert("oWkd.Error: Parameter p_OBJ_EXIST must be a boolean.");
                return;
            }
        }

        // בדיקת תקינות עבור p_NUMBER_CONTENT (חייב להיות מספר שלם)
        if (p_NUMBER_CONTENT != undefined) {
            if (typeof p_NUMBER_CONTENT !== 'number' || !Number.isInteger(p_NUMBER_CONTENT)) {
                alert("oWkd.Error: Parameter p_NUMBER_CONTENT must be an integer number.");
                return;
            }
        }

        // השמה של הערכים
        if (p_OBJ_EXIST != undefined && p_NUMBER_CONTENT != undefined) {
            this.OBJ_EXIST = p_OBJ_EXIST;
            this.NUMBER_CONTENT = p_NUMBER_CONTENT;
        }
        else {
            // ערכי ברירת מחדל
            this.OBJ_EXIST = false;
            this.NUMBER_CONTENT = -1;
        }
    }

    // החזרת שם יום השבוע בעברית
    GetWkd_as_str_v1() {
        if (this.OBJ_EXIST == false || this.NUMBER_CONTENT == (-1)) {
            return "";
        }
        const daysOfWeek = ['יום ראשון', 'יום שני', 'יום שלישי', 'יום רביעי', 'יום חמישי', 'יום שישי', 'יום שבת'];
        const index = (this.NUMBER_CONTENT - 1);
        const wkd_str = daysOfWeek[index];
        return wkd_str;
    }

    GetStrForTableCell_v1() {
        return TRANS.trans_int_to_cell_str_v1(this.OBJ_EXIST, this.NUMBER_CONTENT);
    }

    GetStrForXml_v1() {
        return TRANS.trans_int_to_xml_str(this.OBJ_EXIST, this.NUMBER_CONTENT);
    }

    GetStr() {
        return TRANS.trans_int_to_xml_str(this.OBJ_EXIST, this.NUMBER_CONTENT);
    }
}